import React, { useContext } from 'react'
import { getStepByStepId } from 'app/React/Helpers/StepHelper'
import classNames from 'classnames'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function StepImage(props) {
  const {
    colorImage,
    currentStep,
    currentVariant,
    isDealerConfigurator,
  } = useContext(ConfiguratorContext)

  if (props.step === null) return null

  const steps = currentVariant.steps ?? {}
  const step = getStepByStepId(steps, props.step)

  if (step === null) return null

  let imageUrl = steps[currentStep].image_url
  let showCampaignImage = false

  if (typeof imageUrl === 'undefined' && typeof colorImage !== 'undefined' && colorImage !== null) {
    imageUrl = colorImage.color_image_url
    showCampaignImage = true
  }

  const imageContent = () => {
    if (
      !showCampaignImage ||
      currentStep == 5 ||
      typeof currentVariant.campaign_image_info === 'undefined' ||
      currentVariant.campaign_image_info === null
    ) {
      return (
        <img
          alt={'step-' + props.step}
          src={imageUrl}
          data-object-fit='contain'
        />
      )
    }

    return (
      <div className='campaign-image-container'>
        <img
          className={'campaign-image campaign-image--placement-' + currentVariant.campaign_image_info.placement}
          alt={currentVariant.campaign_image_info.name}
          src={currentVariant.campaign_image_info.image_url}
          data-object-fit='true'
          title={currentVariant.campaign_image_info.name}
        />
        <img
          alt={'step-' + props.step}
          src={imageUrl}
          data-object-fit='contain'
        />
      </div>
    )
  }

  return (
    <div className={classNames('image-container', {
      'has-no-footer': isDealerConfigurator
    })}>
      {imageContent()}
    </div>
  )
}

StepImage.defualtProps = {
  step: null
}
